// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPagination } from './IPagination';
import {
    IPaginationFromJSON,
    IPaginationFromJSONTyped,
    IPaginationToJSON,
    IPaginationToJSONTyped,
} from './IPagination';
import type { ISortCriteriaClaimSortedFieldsType } from './ISortCriteriaClaimSortedFieldsType';
import {
    ISortCriteriaClaimSortedFieldsTypeFromJSON,
    ISortCriteriaClaimSortedFieldsTypeFromJSONTyped,
    ISortCriteriaClaimSortedFieldsTypeToJSON,
    ISortCriteriaClaimSortedFieldsTypeToJSONTyped,
} from './ISortCriteriaClaimSortedFieldsType';

/**
 * 
 * @export
 * @interface IClaimSearchDto
 */
export interface IClaimSearchDto {
    /**
     * 
     * @type {string}
     * @memberof IClaimSearchDto
     */
    category_type?: IClaimSearchDtoCategoryTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof IClaimSearchDto
     */
    claim_status?: Array<IClaimSearchDtoClaimStatusEnum>;
    /**
     * 
     * @type {Date}
     * @memberof IClaimSearchDto
     */
    period_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IClaimSearchDto
     */
    period_to?: Date;
    /**
     * 
     * @type {string}
     * @memberof IClaimSearchDto
     */
    claim_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimSearchDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof IClaimSearchDto
     */
    employee_ids?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof IClaimSearchDto
     */
    organization_ids?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof IClaimSearchDto
     */
    payment_type?: IClaimSearchDtoPaymentTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimSearchDto
     */
    only_my_assignments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimSearchDto
     */
    is_escalated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimSearchDto
     */
    is_appealed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimSearchDto
     */
    is_appeal_processed?: boolean;
    /**
     * 
     * @type {Array<ISortCriteriaClaimSortedFieldsType>}
     * @memberof IClaimSearchDto
     */
    sort_criteria?: Array<ISortCriteriaClaimSortedFieldsType>;
    /**
     * 
     * @type {IPagination}
     * @memberof IClaimSearchDto
     */
    pagination?: IPagination;
}

/**
* @export
* @enum {string}
*/
export enum IClaimSearchDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}
/**
* @export
* @enum {string}
*/
export enum IClaimSearchDtoClaimStatusEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
* @export
* @enum {string}
*/
export enum IClaimSearchDtoPaymentTypeEnum {
    REIMBURSEMENT = 'REIMBURSEMENT',
    BILL_PAY = 'BILL_PAY',
    CARD_SWIPE = 'CARD_SWIPE'
}


/**
 * Check if a given object implements the IClaimSearchDto interface.
 */
export function instanceOfIClaimSearchDto(value: object): value is IClaimSearchDto {
    return true;
}

export function IClaimSearchDtoFromJSON(json: any): IClaimSearchDto {
    return IClaimSearchDtoFromJSONTyped(json, false);
}

export function IClaimSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimSearchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'claim_status': json['claim_status'] == null ? undefined : json['claim_status'],
        'period_from': json['period_from'] == null ? undefined : (new Date(json['period_from'])),
        'period_to': json['period_to'] == null ? undefined : (new Date(json['period_to'])),
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'employee_ids': json['employee_ids'] == null ? undefined : json['employee_ids'],
        'organization_ids': json['organization_ids'] == null ? undefined : json['organization_ids'],
        'payment_type': json['payment_type'] == null ? undefined : json['payment_type'],
        'only_my_assignments': json['only_my_assignments'] == null ? undefined : json['only_my_assignments'],
        'is_escalated': json['is_escalated'] == null ? undefined : json['is_escalated'],
        'is_appealed': json['is_appealed'] == null ? undefined : json['is_appealed'],
        'is_appeal_processed': json['is_appeal_processed'] == null ? undefined : json['is_appeal_processed'],
        'sort_criteria': json['sort_criteria'] == null ? undefined : ((json['sort_criteria'] as Array<any>).map(ISortCriteriaClaimSortedFieldsTypeFromJSON)),
        'pagination': json['pagination'] == null ? undefined : IPaginationFromJSON(json['pagination']),
    };
}

export function IClaimSearchDtoToJSON(json: any): IClaimSearchDto {
    return IClaimSearchDtoToJSONTyped(json, false);
}

export function IClaimSearchDtoToJSONTyped(value?: IClaimSearchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category_type': value['category_type'],
        'claim_status': value['claim_status'],
        'period_from': value['period_from'] == null ? undefined : ((value['period_from']).toISOString()),
        'period_to': value['period_to'] == null ? undefined : ((value['period_to']).toISOString()),
        'claim_id': value['claim_id'],
        'external_identifier': value['external_identifier'],
        'employee_ids': value['employee_ids'],
        'organization_ids': value['organization_ids'],
        'payment_type': value['payment_type'],
        'only_my_assignments': value['only_my_assignments'],
        'is_escalated': value['is_escalated'],
        'is_appealed': value['is_appealed'],
        'is_appeal_processed': value['is_appeal_processed'],
        'sort_criteria': value['sort_criteria'] == null ? undefined : ((value['sort_criteria'] as Array<any>).map(ISortCriteriaClaimSortedFieldsTypeToJSON)),
        'pagination': IPaginationToJSON(value['pagination']),
    };
}

